import { type SerializableRecord } from '@post-office/serializable-record';

export const showMarkAllAsReadButton = (
	currentMessages: SerializableRecord[] | undefined,
): boolean =>
	currentMessages ? currentMessages.some((message) => message['readStatus'] === 'unread') : false;
